<template>
  <div :class="['schedule-overlay-container', isOpen && 'schedule-overlay-container--visible']">
    <div class="schedule-overlay-container__header">
      <slot name="header">
      </slot>
    </div>
    <slot name="body">
    </slot>
    <b-loading :active="isOpen && isLoading" :is-full-page="false" />
  </div>
</template>

<script>
export default {
  name: 'schedule-overlay-container',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({

  }),
  methods: {

  }
}
</script>

<style lang="scss">
.schedule-overlay-container {
  position: absolute;
  top: 95px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 14;
  visibility: hidden;
  background-color: $background;
  border-top: 1px solid $panel;

  &.schedule-overlay-container--visible {
    visibility: visible;
  }

  .icon-container.info.fa-spin {
    color: unset;
    background: unset;
  }

  .schedule-overlay-container__header {
    position: absolute;
    top: -52px;
    right: 0px;
    bottom: 26px;
    left: 418px;
    height: 51px;
    z-index: 12;
    background-color: $secondary;
    border-left: 2px solid $panel;
    border-bottom: 1px solid $panel;
  }
}
</style>